<template>
    <div class="orderDetail">
        <BookingBack :isDark="true" title="Order Details"/>
        <div class="orderData" v-if="orderData != null">
            <div class="serviceInfo">
                <div class="title">Service Info</div>
                <OrderAddress :shopName="supplierInfo.name || ''" :address="supplierInfo.address || ''" :distance="orderData.distance" :lat="supplierLat" :lng="supplierLng"/>
                <van-divider/>
                <OrderPhone :phone="supplierInfo.link_phone || ''"/>
                <div class="orderList">
                    <template v-for="(item, index) in orderData.service">
                        <PayOrderList :key="item.order_service_id || item.id" :list="item" :timezone="supplierInfo.timezone || ''" />
                        <!-- 等待时间间隔 -->
                        <div class="waitingTime" v-if="index < orderData.service.length - 1" :key="'wait-' + index">
                            <div class="waitingLine"></div>
                            <div class="waitingText">WAITING TIME: {{ getWaitingTime(index) }} MIN</div>
                            <div class="waitingLine"></div>
                        </div>
                    </template>
                     <van-divider :style="{width:'100%',color: '#333333', borderColor: '#cccccc' }"></van-divider>
                    <div class="amountDetail">
                        <div><span>Subtotal</span><span>$ {{ orderData.total_price }}</span></div>
                        <div><span>Gift Card</span><span>-$ {{ orderData.gift_card_money || '0.00' }}</span></div>
                        <div><span>Stripe Service Amount</span><span>$ {{ orderData.stripe_service_amount || '0.00' }}</span></div>
                        <div><span>Processing Fee</span><span>$ {{ orderData.processing_fee || '0.00' }}</span></div>
                        <div><span>Online Tip</span><span>$ {{ orderData.tip_fee || '0.00' }}</span></div>
                        <div class="totalPrice"><span>Total</span><span>$ {{ orderData.order_total || orderData.total_price }}</span></div>
                    </div>
                </div>
            </div>
            <div class="title">Order Info</div>
            <OrderInfo :orderInfo="orderData" :timezone="supplierInfo.timezone"/>
            <OrderBtn v-if="orderData.order_status == 10 ">
                <div class="Btn2" @click.stop="handleCancel">Cancel Order</div>
                <!-- pay_status = 0 未付款, pay_type = 2 或 4 -->
                <div class="Btn1" v-if="orderData.pay_status == 0 && (orderData.pay_type == 2 || orderData.pay_type == 4)" @click.stop="handlePay" >Pending Payment</div>
            </OrderBtn>
            <!-- order_status = 30 Completed -->
            <OrderBtn v-if="orderData.order_status == 30 ">
                <!-- ReviewedOrders不显示“追加评价”按钮 -->
                <div class="Btn1" v-if="isUnreviewed(orderData)" @click.stop="handleCollection">Review Now</div>
            </OrderBtn>
        </div>
        <van-skeleton title  :row="10" :loading="loading"></van-skeleton>
    </div>
</template>
<script>
import { Dialog,Toast  } from 'vant'
import BookingBack from '@/components/Booking/back.vue'
import OrderAddress from '@/components/Order/address.vue'
import OrderPhone from '@/components/Order/phone.vue'
import PayOrderList from '@/components/Pay/orderList.vue'
import OrderInfo from '@/components/Order/orderInfo.vue'
import OrderBtn from '@/components/Order/btn.vue'
import { ensureUserLngLat } from '@/utils/location'
export default {
    name:'OrderDetail',
    data(){
        return {
            order_id:this.$route.query.id,
            orderData:null,
            supplierInfo:{},
            loading:true,
        }
    },
    components:{
        BookingBack,
        OrderAddress,
        OrderPhone,
        PayOrderList,
        OrderInfo,
        OrderBtn
    },
    computed: {
        supplierLat() {
            const raw = this.supplierInfo.latitude || this.supplierInfo.lat || this.supplierInfo.shop_lat
            const n = Number(raw)
            return Number.isFinite(n) ? n : ''
        },
        supplierLng() {
            const raw = this.supplierInfo.longitude || this.supplierInfo.lng || this.supplierInfo.shop_lng
            const n = Number(raw)
            return Number.isFinite(n) ? n : ''
        }
    },
    created(){
        this.getOrderDetail()
    },
    methods:{
        isUnreviewed(order){
            return !!order && Number(order.is_comment) === 0
        },
        getWaitingTime(index) {
            const services = this.orderData?.service
            if (!services || index >= services.length - 1) return 0
            const currentItem = services[index]
            const nextItem = services[index + 1]
            // 计算当前Services开始时间到下一个Services开始时间的间隔
            let currentStartTime = currentItem.start_time
            let nextStartTime = nextItem.start_time
            // 转换为时间戳
            if (typeof currentStartTime === 'string') {
                currentStartTime = new Date(currentStartTime).getTime()
            }
            if (typeof nextStartTime === 'string') {
                nextStartTime = new Date(nextStartTime).getTime()
            }
            // 如果是10位时间戳转为毫秒
            if (currentStartTime.toString().length === 10) currentStartTime *= 1000
            if (nextStartTime.toString().length === 10) nextStartTime *= 1000
            // 计算等待时间（分钟）
            const waitingMs = nextStartTime - currentStartTime
            const waitingMin = Math.max(0, Math.round(waitingMs / 60000))
            return waitingMin
        },
        async getOrderDetail(){
            // Best-effort: fetch/cache user's lng/lat before requesting order detail.
            await ensureUserLngLat().catch(() => {})
            const result = await this.$api.getOrderDetail({order_id:this.order_id})
            if(result.code == 1){
                this.orderData = result.data.order
                // 按开始时间排序Services列表
                if (this.orderData.service && this.orderData.service.length > 1) {
                    this.orderData.service.sort((a, b) => {
                        return this.parseTime(a.start_time) - this.parseTime(b.start_time)
                    })
                }
                this.loading = false
                // 获取店铺详情
                if(this.orderData.shop_supplier_id){
                    this.getSupplierDetail(this.orderData.shop_supplier_id)
                }
            }
        },
        // 解析时间为时间戳
        parseTime(time) {
            if (!time) return 0
            if (typeof time === 'number') {
                return time.toString().length === 10 ? time * 1000 : time
            }
            return new Date(time).getTime()
        },
        // 获取店铺详情
        async getSupplierDetail(shop_supplier_id){
            const result = await this.$api.getSupplierDetail({shop_supplier_id: shop_supplier_id})
            if(result.code == 1 && result.data && result.data.detail){
                this.supplierInfo = result.data.detail
            }
        },
        // 取消 Order
        handleCancel(){
            Dialog.confirm({
                title: 'Delete',
                message: 'Cancel this booking? Paid orders are not refunded online; please contact the store to discuss a refund in person.',
            })
            .then(async () => {
                const res = await this.$api.cancelOrder({ order_id: this.order_id })
                if(res.code == 1){
                    Toast.success('Order cancelled')
                    // 取消后刷新详情数据，保证状态and按钮实时更新
                    this.loading = true
                    await this.getOrderDetail()
                }else{
                    Toast.fail(res.msg)
                }
            })
            .catch(() => {
            });
        },
        // Review Now
        handleCollection(){
            let service = this.orderData.service
            let order_service_arr = []
            for( let i in service ){
                order_service_arr.push({order_service_id:service[i].order_service_id,service_id:service[i].service_id})
            }
            this.$router.push({path:'/orderCollection',query:{order_id:this.orderData.order_id,data:JSON.stringify(order_service_arr)}})
        },
        // 待支付
        async handlePay(){
            const { getAbsoluteHashUrl, startStripeCheckout } = await import('@/utils/stripeCheckout')
            const res = await this.$api.orderPay({
                order_id: this.orderData.order_id,
                success_url: getAbsoluteHashUrl('/order?pay=success'),
                cancel_url: getAbsoluteHashUrl(`/orderDetail?id=${this.orderData.order_id}&pay=cancel`)
            })
            if(res.code == 1 && res.data){
                try {
                    await startStripeCheckout({
                        checkoutUrl: res.data.checkout_url
                    })
                } catch (e) {
                    Toast.fail(e.message || 'Failed to redirect to payment')
                }
            }else{
                Toast.fail(res.msg || 'Payment failed')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .amountDetail{
        display: flex;
        flex-direction: column;
        gap: .5rem;
        > div{
            display: flex;
            justify-content: space-between;
        }
        .totalPrice{
            padding-top: .5rem;
            border-top: 1px solid #ccc;
            font-weight: 600;
        }
    }
    .orderList{
        width: 100%;
        background: #F4F4F4;
        border-radius: .5rem;
        padding: 1rem;
        box-sizing: border-box;
        margin: 1rem 0;
        font-size: .875rem;
    }
    .waitingTime {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 1rem 0;
        .waitingLine {
            flex: 1;
            height: 1px;
            background: #CCCCCC;
        }
        .waitingText {
            padding: 0 0.75rem;
            font-size: 0.75rem;
            color: #999999;
            white-space: nowrap;
        }
    }
    .orderData{
        width: 100%;
        padding:1rem;
        box-sizing: border-box;
        .title{
                font-size: .875rem;
                color: #666666;
                margin-bottom: 1rem;
            }
    }
    .Btn2{
        width: 100%;
        height: 2.75rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .25rem;
        border: 1px solid #1E3C3E;
    }
    .Btn1{
        width:100%;
        height: 2.75rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: .25rem;
        color: #FFFFFF;
        background: #1E3C3E;
    }
    // .salesBtn{
    //     background: #fff;
    //     border: 1px solid #1E3C3E;
    //     color: #1E3C3E;
    // }
    // .cancelBtn{
    //         background: #1E3C3E;
    //     color: #fff;
    // }
    // .appraiseBtn{
    //     background: #1E3C3E;
    //     color: #fff;
    // }
</style>
